import styled from 'styled-components';
import { baseTheme } from '../../../../../../global/styles/theme';

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .progress-header {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 600;
    color: ${baseTheme.colors.secondary};

    .progress-count {
      color: ${baseTheme.colors.primary};
    }
  }
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 6px;
  background: ${baseTheme.colors.stroking};
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ percent: number; isDone: boolean }>`
  width: ${({ percent }) => percent}%;
  height: 100%;
  border-radius: 6px;
  background: ${({ isDone }) =>
    isDone ? baseTheme.colors.focus : baseTheme.colors.mainLightBlue};
  transition: width 0.4s ease, background 0.4s ease;
`;

export const StatusChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;

  .chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border-radius: 10px;
    border: 1px solid ${baseTheme.colors.stroking};
    background: ${baseTheme.colors.background};
    font-size: 13px;
    font-weight: 700;
    color: ${baseTheme.colors.disabled};
    opacity: 0.6;
    transition: opacity 0.2s;

    &.active {
      opacity: 1;
    }
  }

  .chip-icon {
    font-size: 14px;
    line-height: 1;
  }
`;
